import { render, staticRenderFns } from "./povertyAlleviation.vue?vue&type=template&id=013759b0&scoped=true"
import script from "./povertyAlleviation.vue?vue&type=script&lang=js"
export * from "./povertyAlleviation.vue?vue&type=script&lang=js"
import style0 from "./povertyAlleviation.vue?vue&type=style&index=0&id=013759b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013759b0",
  null
  
)

export default component.exports